export default __webpack_public_path__ + "static/media/bee.a85ef10e.png";